module.exports = __webpack_public_path__ + "img/placeholder-user.ba91137c.png";